import styled from 'styled-components';
import device from '../../mediaQueries';

const SearchWrapper = styled.div`
  display: flex;
  ${device.mobile`
    background-color: #FFFFFF;
    min-height: 99%;
    position: fixed;
    top: 50px;
    width: 100%;
    z-index: 10;
    justify-content: center;
  `}
`;

export default SearchWrapper;
